export default "__VITE_ASSET__DjBlD9sO__"